// apps/client/src/pages/dashboard/components/AddProjectCard.tsx
import { AddCircleOutline } from '@mui/icons-material';
import { Box, Card, CardActionArea, CardContent, Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const AddProjectCard: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/app/projects');
  };

  return (
    <Card
      sx={{
        height: '100%',
        border: 2,
        borderStyle: 'dashed',
        borderColor: 'divider',
        bgcolor: 'grey.50',
        transition: 'all 0.2s',
        '&:hover': {
          borderColor: 'primary.main',
          bgcolor: 'primary.50',
          boxShadow: 2,
        },
      }}
    >
      <CardActionArea
        onClick={handleClick}
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CardContent
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            minHeight: 300,
          }}
        >
          <Stack spacing={2} alignItems="center">
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                bgcolor: 'primary.100',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s',
                '.MuiCardActionArea-root:hover &': {
                  bgcolor: 'primary.200',
                  transform: 'scale(1.1)',
                },
              }}
            >
              <AddCircleOutline
                sx={{
                  fontSize: 48,
                  color: 'primary.main',
                }}
              />
            </Box>

            <Box>
              <Typography variant="h6" fontWeight={600} color="text.primary" sx={{ mb: 0.5 }}>
                Create New Project
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 240 }}>
                Set up a new R&D project to track your research and development activities
              </Typography>
            </Box>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default AddProjectCard;
